module.exports = {
	"id": "AX",
	"name": "Aland Islands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.019329,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.012886,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.006443,
			"34": 0.045101,
			"35": 0.006443,
			"36": 0.032215,
			"37": null,
			"38": 0.051544,
			"39": 0.019329,
			"40": 0.012886,
			"41": null,
			"42": 0.025772,
			"43": null,
			"44": 0.006443,
			"45": null,
			"46": 0.019329,
			"47": 0.006443,
			"48": 0.032215,
			"49": 1.733167,
			"50": 0.090202,
			"51": 0.251277,
			"52": 0.154632,
			"53": 25.198573,
			"54": 7.53831,
			"55": 0.231948,
			"56": 0.070873,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.012886,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.006443,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.025772,
			"30": null,
			"31": 0.038658,
			"32": null,
			"33": null,
			"34": 0.019329,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.045101,
			"39": null,
			"40": 0.012886,
			"41": null,
			"42": 0.019329,
			"43": 0.161075,
			"44": 0.006443,
			"45": 0.109531,
			"46": 0.012886,
			"47": 0.251277,
			"48": 0.412352,
			"49": 8.865568,
			"50": 0.012886,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": 0.019329,
			"40": 0.19329,
			"41": 0.032215,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.057987
		},
		"safari": {
			"0": null,
			"4": 0.012886,
			"5": 0.019329,
			"6": null,
			"7": 0.057987,
			"8": 0.154632,
			"9": 0.296378,
			"10": 1.945786,
			"3.1": null,
			"3.2": null,
			"5.1": 0.103088,
			"6.1": 0.096645,
			"7.1": 0.012886,
			"9.1": 3.189285
		},
		"ios_saf": {
			"8": 0,
			"10": 10.6404826578,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.286748695254,
			"8.1-8.4": 0.529756064113,
			"9.0-9.2": 0.252727663614,
			"9.3": 3.85571691923
		},
		"android": {
			"3": 0,
			"4": 0.0108088682171,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00135110852713,
			"4.1": 0.0389891317829,
			"4.2-4.3": 0.0974728294574,
			"4.4": 0.223511953488,
			"4.4.3-4.4.4": 0.225442108527
		},
		"ie": {
			"6": null,
			"7": 0.006443,
			"8": 0.057987,
			"9": 0.277049,
			"10": 0.289935,
			"11": 7.042199,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0159445083913,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000442903010869
		},
		"edge": {
			"12": 0.025772,
			"13": 0.734502,
			"14": 3.131298
		},
		"ie_mob": {
			"10": 0.218830647887,
			"11": 0.890953352113
		},
		"bb": {
			"7": 0.0017785,
			"10": null
		},
		"samsung": {
			"0": 4.862419
		},
		"and_uc": {
			"0": 0.156508
		},
		"op_mini": {
			"0": 0.214817588598
		},
		"and_chr": {
			"0": 13.494803
		},
		"and_ff": {
			"0": 0.014228
		}
	},
	"total": 99.3684235
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AX.json
 ** module id = 469
 ** module chunks = 0
 **/